import { Instance, types } from 'mobx-state-tree';
import {
    CategoryData,
    TypeCategoryDataModel,
} from '@stores/content-stores/models/blog-category-model';

const ServicesModel = types.model('ServicesModel', {
    en_US: types.optional(types.string, '', [undefined, null]),
    fr_CA: types.optional(types.string, '', [undefined, null]),
    ja_JP: types.optional(types.string, '', [undefined, null]),
    ko_KR: types.optional(types.string, '', [undefined, null]),
    zh_CN: types.optional(types.string, '', [undefined, null]),
});

const FieldsModel = types.model('NewsAndMediaInfoPagesModel', {
    fieldName: types.string,
    isImage: types.boolean,
    isLink: types.boolean,
    isSortable: types.boolean,
    type: types.enumeration('type', ['integer', 'string', 'array', 'object']),
});

const NewsAndMediaInfoModel = types.model('NewsAndMediaInfoModel', {
    fields: types.array(FieldsModel),
    tags: types.map(types.optional(CategoryData, {} as TypeCategoryDataModel, [null, undefined])),
});
export type TypeNewsAndMediaInfoModel = Instance<typeof NewsAndMediaInfoModel>;

export default NewsAndMediaInfoModel;
